import React, { useCallback, useState } from "react";
import { InputTextBox } from "../../common/input/InputTextBox";
import { Button } from "../../common/button/Button";
import { BackButton } from "../../common/button/BackButton";
import { ServiceProviderName } from "../../../../domain/service_provider/ServiceProviderName";
import { ServiceProviderSpId } from "../../../../domain/service_provider/ServiceProviderSpId";
import { ServiceProviderSharedPassword } from "../../../../domain/service_provider/ServiceProviderSharedPassword";

export const AdminServiceProviderEditComponent = React.memo(function AdminServiceProviderEditComponent(props: AdminServiceProviderEditParams) {
    const {
        category,
        serviceProviderName,
        serviceProviderSpId,
        serviceProviderSharedPassword,
        handleServiceProviderNameChanged,
        handleSetServiceProviderSpIdChanged,
        handleSetServiceProviderSharedPasswordChanged,
        handleServiceProviderUpsertClicked
    } = props;

    const [nameError, setNameError] = useState("");

    const [spIdError, setSpIdError] = useState("");

    const [sharedPasswordError, setSharedPasswordError] = useState("");

    const upsertClicked = useCallback(() => {
        let hasError = false;

        setNameError("");
        setSpIdError("");
        setSharedPasswordError("");

        if (!ServiceProviderName.fromString(serviceProviderName).isValidLength()) {
            setNameError("名前は1文字以上200文字以下で入力して下さい。");
            hasError = true;
        }

        if (!ServiceProviderSpId.fromString(serviceProviderSpId).isValidLength()) {
            setSpIdError("SPIDは1文字以上200文字以下で入力して下さい。");
            hasError = true;
        }

        if (!ServiceProviderSharedPassword.fromString(serviceProviderSharedPassword).isValidLength()) {
            setSharedPasswordError("共有パスワードは1文字以上200文字以下で入力して下さい。");
            hasError = true;
        }

        if (hasError) return;

        handleServiceProviderUpsertClicked();
    }, [serviceProviderName, serviceProviderSpId, serviceProviderSharedPassword, handleServiceProviderUpsertClicked]);

    return (
        <div className={"service_provider_edit_page"}>
            <div className={"container"}>
                <BackButton />
                <p className={"header"}>事業者{category}</p>
                <div className={"service_provider_edit"}>
                    <div className={"content"}>
                        <div className="label">事業者名</div>
                        <InputTextBox value={serviceProviderName} handleTextChanged={handleServiceProviderNameChanged} />
                        <div className={"error_message"}>{nameError}</div>
                    </div>
                    <div className={"content"}>
                        <div className="label">SPID</div>
                        <InputTextBox value={serviceProviderSpId} handleTextChanged={handleSetServiceProviderSpIdChanged} />
                        <div className={"error_message"}>{spIdError}</div>
                    </div>
                    <div className={"content"}>
                        <div className="label">共有パスワード</div>
                        <InputTextBox value={serviceProviderSharedPassword} handleTextChanged={handleSetServiceProviderSharedPasswordChanged} />
                        <div className={"error_message"}>{sharedPasswordError}</div>
                    </div>
                    <Button label={category} onClick={upsertClicked} />
                </div>
            </div>
        </div>
    );
});

export type AdminServiceProviderEditParams = {
    category: string,
    serviceProviderName: string,
    serviceProviderSpId: string,
    serviceProviderSharedPassword: string,
    handleServiceProviderNameChanged: (value: string) => void,
    handleSetServiceProviderSpIdChanged: (value: string) => void,
    handleSetServiceProviderSharedPasswordChanged: (value: string) => void,
    handleServiceProviderUpsertClicked: () => void
};
